// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mZiKVaguakDdStS1unGg{align-items:center;gap:4px;display:flex}.TtmwdlZegC0xWmb19imS{color:var(--content-primary-primary);font-weight:500}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `mZiKVaguakDdStS1unGg`,
	"activeNameSpan": `TtmwdlZegC0xWmb19imS`
};
export default ___CSS_LOADER_EXPORT___;
